(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiredba1"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiredba1"] = parcelRequire;
}
parcelRequire.register("5pfIs", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $3efb7a6b954c2942$export$6503ec6e8aabbaf; }, function (v) { return $3efb7a6b954c2942$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $3efb7a6b954c2942$export$f7ad0328861e2f03; }, function (v) { return $3efb7a6b954c2942$export$f7ad0328861e2f03 = v; });
var $3efb7a6b954c2942$export$6503ec6e8aabbaf;
var $3efb7a6b954c2942$export$f7ad0328861e2f03;
"use strict";
var $3efb7a6b954c2942$var$mapping = {};
function $3efb7a6b954c2942$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$3efb7a6b954c2942$var$mapping[keys[i]] = pairs[keys[i]];
}
function $3efb7a6b954c2942$var$resolve(id) {
    var resolved = $3efb7a6b954c2942$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$3efb7a6b954c2942$export$6503ec6e8aabbaf = $3efb7a6b954c2942$var$register;
$3efb7a6b954c2942$export$f7ad0328861e2f03 = $3efb7a6b954c2942$var$resolve;

});

var $451fcd1e28cd1aa7$exports = {};

(parcelRequire("5pfIs")).register(JSON.parse('{"eot5l":"index.4b346f32.js","lhX5j":"ae_logo_flat.738148a8.svg","f2x3T":"onfido_logo.c2975af7.svg","aBEzp":"idin_logo.2a32eee0.svg","8knTd":"complete-check.11e9d857.svg","fE69V":"driving_licence.3350db06.svg","ipaVF":"national_identity_card.0cd2d97c.svg","iBhv9":"passport.76e1f841.svg","eFsTe":"residence_permit.43b1cb42.svg","g5wjA":"search_icon.209df2db.svg","6lvuX":"index.cbaee750.css"}'));

})();
//# sourceMappingURL=index.58edb625.js.map
